import React from 'react';
import { ActionButtonGroup, PauseBillingDetailsFooter } from '../../../shared';
import { useBillingActions, useFlowActions } from '../../../../context';

/**
 * Component that displays the pause offer for users who select "notUsing" as their reason
 * Offers a 30-day billing pause with feature highlights and exploration encouragement
 */
const NotUsingPauseOffer = () => {
  // Get actions from context
  const { pause } = useBillingActions();
  const { cancelAnyway } = useFlowActions();

  return (
    <div className="not-using-pause-offer-content">
      <div className="mb-4">
        <h5 className="mb-3">Thanks for letting us know you haven't been using WHOLE Life Club much lately.</h5>
        <p className="mb-3">It happens. Life gets full, and even our best intentions can slide out of focus.</p>
        <p className="mb-3">
          But before you go, we want to make it easy for you to take a fresh look without pressure.
        </p>
        <p className="mb-3">
          If you'd like, instead of canceling, you can <strong>pause your billing for 30 days</strong> and still keep
          full access to everything WHOLE Life Club offers:
        </p>

        <div className="mb-4">
          <ul className="list-unstyled mb-0">
            <li className="mb-2">🌱 Wellness Buddy to help you find what's most relevant to your needs</li>
            <li className="mb-2">🥗 1,500+ simple, satisfying recipes, filterable by ingredients and meal type</li>
            <li className="mb-2">🎓 Unlimited expert-led lessons that meet you where you are</li>
            <li className="mb-2">💬 A supportive community to help you stay inspired and connected</li>
          </ul>
        </div>

        <p className="mb-4">
          Think of it as a free month to reset, explore at your own pace, and discover what works best for your routine
          right now.
        </p>

        <ActionButtonGroup
          primaryAction={{
            text: 'Pause My Billing (Keep My Access)',
            onClick: pause,
            color: 'primary',
            className: 'mb-3'
          }}
          secondaryAction={{
            text: 'Cancel Anyway',
            onClick: cancelAnyway
          }}
          layout="vertical"
        />

        <PauseBillingDetailsFooter className="pause-details mb-3" />
      </div>
    </div>
  );
};

export default NotUsingPauseOffer;
